import RazorpayService from "./RazorpayService";
import PayUService from "./PayUService";

class PaymentService {
  static gateways = {
    razorpay: new RazorpayService(),
    payu: new PayUService(),
  };

  static pay(method, paymentData) {
    const gateway = this.gateways[method];

    if (!gateway) {
      throw new Error("Unsupported payment gateway");
    }

    return gateway.pay(paymentData);
  }
}

export default PaymentService;
